import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAuthenticateUserMutation } from "../../core/data/redux/apis/userService";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import { loginSuccess } from "../../core/data/redux/authSlice";
import { setPermissions } from "../../core/data/redux/userPermissionSlice";

// Define Yup validation schema
const userSchema = Yup.object().shape({
  userName: Yup.string().required("User Name is required"),
  password: Yup.string().required("Password is required"),
});

const Login = () => {
  const dispatch = useDispatch();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [authenticateUser, { isLoading }] = useAuthenticateUserMutation();
  // const [userId, setUserId] = useState(1);
  // const { data: userPermissions } = useGetUserPermissionsByUserIdQuery(userId, {
  //   skip: userId === 0,
  // });
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(userSchema),
  });

  // Submit handler
  const onSubmit = async (data: any) => {
    try {
      const response = await authenticateUser(data).unwrap();
      if (response.data.success) {
      }
      localStorage.setItem("authToken", response?.data?.JwtToken);
      localStorage.setItem("refreshToken", response?.data?.RefreshToken);
      const authToken = response?.data?.authToken;
      const userId = response?.data?.userId;
      const userFullName = response?.data?.fullName;
      const userRoleName = response?.data?.roleName;
      const permissions = response?.data?.permissions;
      // handleGetUserPermissions(userId);
      dispatch(
        loginSuccess({
          authtoken: authToken,
          user: {
            userId: userId,
            userFullName: userFullName,
            userRoleName: userRoleName,
          },
        })
      );
      dispatch(setPermissions(permissions?.map((p: any) => p.module)));
      toast.success(`${response?.data?.fullName} Login successful`);
      reset();
      navigate("/dashboard");
    } catch (error: any) {
      toast.error(`${error?.data?.message}`);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  useEffect(() => {
    localStorage.setItem("menuOpened", "Dashboard");
  }, []);
  return (
    <div className="account-content">
      <div className="d-flex flex-column flex-md-row w-100 vh-100">
        {/* Left Side: Form Card */}
        <div className="form-card d-flex align-items-center justify-content-center p-4 w-100 w-md-50">
          <form onSubmit={handleSubmit(onSubmit)} className="mx-auto mw-450">
            <div className="text-center mb-4 d-flex align-items-center justify-content-center">
              <ImageWithBasePath
                src="assets/img/logo.png"
                className="logo-img"
                alt="Logo"
              />
              <span className="ms-2 fw-bold company-name">ZARCRM</span>
            </div>
            <div className="mb-4">
              <h4>Sign In</h4>
              <p>Access the CRM panel using your username and passcode.</p>
            </div>
            <div className="mb-3">
              <label className="col-form-label">User Name</label>
              <div className="position-relative">
                <span className="input-icon-addon">
                  <i className="ti ti-mail"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  {...register("userName")}
                />
                {errors.userName && (
                  <span className="text-danger">{errors.userName.message}</span>
                )}
              </div>
            </div>
            <div className="mb-3">
              <label className="col-form-label">Password</label>
              <div className="pass-group">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  className="pass-input form-control"
                  {...register("password")}
                />
                {errors.password && (
                  <span className="text-danger">{errors.password.message}</span>
                )}
                <span
                  className={`ti toggle-password ${
                    isPasswordVisible ? "ti-eye" : "ti-eye-off"
                  }`}
                  onClick={togglePasswordVisibility}
                ></span>
              </div>
            </div>
            <div className="mb-3 mt-5">
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isLoading}
              >
                {isLoading ? "Authenticating..." : "Sign In"}
              </button>
            </div>
            <div className="text-center">
              <p className="fw-medium text-gray">Copyright © 2024 - CRM</p>
            </div>
          </form>
        </div>

        {/* Right Side: Background Image */}
        <div className="account-bg-01 w-50 d-none d-md-block"></div>
      </div>
    </div>
  );
};

export default Login;
